import { handleActions, combineActions } from 'redux-actions';
import * as actions from '../actions';

const defaultState = {
  current: {
    properties: [],
  },
  firms: [],
  firmsForLookup: [],
  reps: [],
  listings: [],
  listingOptions: [],
  modalOpen: false,
};

const toOptionItem = record => {
  return {
    key: record.id,
    text: record.name,
    value: record.id,
  };
};

const mapRecordsToOptions = records => {
  return records.map(toOptionItem);
};

const reducer = handleActions(
  {
    [combineActions(actions.firm.getFirmsSuccess, actions.firm.searchFirmsSuccess)]: (
      state,
      { payload: { firms } }
    ) => {
      return {
        ...state,
        firms,
      };
    },
    [combineActions(actions.firm.getFirmsForLookupSuccess)]: (state, { payload: { firms } }) => {
      return {
        ...state,
        firmsForLookup: firms,
      };
    },
    [combineActions(actions.firm.setCurrentFirm, actions.firm.getFirmByIdSuccess)]: (state, { payload: { firm } }) => {
      return {
        ...state,
        current: firm,
        reps: firm.representatives,
      };
    },
    [actions.rep.getRepsSuccess]: (state, { payload: { reps } }) => {
      return { ...state, reps };
    },
    [actions.firm.setModalOpen]: (state, { payload: { isOpen } }) => {
      return { ...state, modalOpen: isOpen };
    },
    [actions.listing.getListingsSuccess]: (state, { payload: { listings } }) => {
      return { ...state, listings, listingOptions: mapRecordsToOptions(listings) };
    },
  },
  defaultState
);

export default reducer;
